// extracted by mini-css-extract-plugin
export default {"Grid":"BetTicketsContainer_Grid__R0vpj","GridCentered":"BetTicketsContainer_GridCentered__Dc771","MobileContainer":"BetTicketsContainer_MobileContainer__rab3P"};